import React from 'react'
import testSpi from "../../imagens/imagensTestes/testeSpi.png"
import testSpi2 from "../../imagens/imagensTestes/testeSpi2.png"
import testSpi3 from "../../imagens/imagensTestes/testeSpi3.png"
import testSpi4 from "../../imagens/imagensTestes/testeSpi4.png"
import testSpi5 from "../../imagens/imagensTestes/testeSpi5.JPG"
import testSpi6 from "../../imagens/imagensTestes/testeSpi6.JPG"
import testSpi7 from "../../imagens/imagensTestes/testeSpi7.JPG"
import testSpi8 from "../../imagens/imagensTestes/testeSpi8.JPG"
import testSpi9 from "../../imagens/imagensTestes/testeSpi9.JPG"
import testSpi10 from "../../imagens/imagensTestes/testeSpi10.JPG"
import testSpi11 from "../../imagens/imagensTestes/testeSpi11.JPG"
import Header from '../../Components/Header'
import WireTestCapabilities from '../../Components/wireTestsCapabilities'

const listWireTest = [
    {
        img: testSpi2
    },
    {
        img: testSpi3
    },
    {
        img: testSpi4
    },
    {
        img: testSpi5
    },
    {
        img: testSpi6
    },
    {
        img: testSpi7
    },
    {
        img: testSpi8
    },
    {
        img: testSpi9
    },
    {
        img: testSpi10
    },
    {
        img: testSpi11
    },
    {
        img: testSpi
    },

]



function WireTestPage() {
    return (
        <div>
            <Header />

                <WireTestCapabilities
                    listWireTest={listWireTest}
                />
        </div>
    )
}

export default WireTestPage